import { CardType, NULLIFY_FIELD } from '../constants/payments';
export const mapB2BPaymentCardsToCommonModel = ({ paymentCards, paginationInfo, filterConfig, oldPaginationInfo, businessName, t2cNumber, t2cApprovers, }) => {
    const mappedCards = paymentCards.map((card) => {
        var _a, _b, _c, _d, _e, _f;
        return {
            addedBy: card.addedBy,
            actions: card.actions,
            operations: card.operations,
            addressId: ((_a = card.billingAddress) === null || _a === void 0 ? void 0 : _a.addressId) || '',
            addressLine1: ((_b = card.billingAddress) === null || _b === void 0 ? void 0 : _b.addressLine1) || '',
            addressLine2: ((_c = card.billingAddress) === null || _c === void 0 ? void 0 : _c.addressLine2) || '',
            cardBrand: card.cardBrand || '',
            cardExpiryMonth: card.cardExpiryMonth || '',
            cardExpiryYear: card.cardExpiryYear || '',
            cardHolderName: card.cardHolderName || '',
            cardNickName: card.cardNickName,
            cardNumber: card.cardNumber || '',
            cardNumberLast4: card.cardNumberLast4 || '',
            cardStatus: card.cardStatus,
            cardType: card.cardBrandType || '',
            city: ((_d = card.billingAddress) === null || _d === void 0 ? void 0 : _d.cityName) || '',
            authorizeFlag: card.authorizeFlag,
            isCardExpired: card.isCardExpired,
            isDefault: card.isDefault || false,
            lastModifiedDate: card.lastModifiedDate,
            paymentId: card.paymentId || '',
            state: ((_e = card.billingAddress) === null || _e === void 0 ? void 0 : _e.stateCode) || '',
            zipCode: ((_f = card.billingAddress) === null || _f === void 0 ? void 0 : _f.postalCode) || '',
            buyerId: card.buyerId || '',
            t2cStatus: card.t2cStatus,
            t2cNumber: card.t2cNumber || undefined,
            activeT2COnFile: paginationInfo.t2cNumber || card.t2cNumber || t2cNumber || null,
            t2cPrimary: card.t2cPrimary,
            paypalAccountId: card.paypalAccountId,
            rewardExpDate: card.rewardExpDate,
            rewardStartDate: card.rewardStartDate,
            gcBalance: card.gcBalance,
            userId: card.userId,
            level: card.level || '',
            citiAccountId: card.citiAccountId || '',
            citiPrimary: card.citiPrimary || '',
            trackingOnly: card.trackingOnly,
            hdWalletAuthorized: card.hdWalletAuthorized || 'N',
            locType: card.locType,
            locBuyerId: card.locBuyerId || '',
            locName: card.locType === 'SHOP' ? businessName || '' : card.locName || '',
        };
    });
    const mappedPaginationInfo = {
        pageNumber: Number(paginationInfo.pn) || 0,
        pageSize: Number(paginationInfo.ps) || 0,
        totalCreditCards: (filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterType)
            ? (oldPaginationInfo === null || oldPaginationInfo === void 0 ? void 0 : oldPaginationInfo.totalCreditCards) || 0
            : paginationInfo.totalCC || 0,
        totalSearchedCreditCards: (filterConfig === null || filterConfig === void 0 ? void 0 : filterConfig.filterType)
            ? paginationInfo.totalCC || 0
            : 0,
        totalPayPalAccounts: paginationInfo.totalPBA || 0,
        totalGiftCards: paginationInfo.totalGC || 0,
        totalProXtraDollars: paginationInfo.totalPGC || 0,
        totalCheckingAccounts: paginationInfo.totalCA || 0,
        totalKeyTags: paginationInfo.totalKT || 0,
        totalLinesOfCredit: paginationInfo.totalLOC || 0,
        totalPages: Number(paginationInfo.totalPages) || 0,
        paymentsOnCurrentPage: paymentCards.length || 0,
        citiCardsSummary: paginationInfo.citiCardsSummary || [],
        t2cNumber: paginationInfo.t2cNumber || undefined,
    };
    return {
        paymentCards: {
            paymentCards: mappedCards,
            response: paymentCards,
        },
        paginationInfo: mappedPaginationInfo,
        t2cApprovers,
    };
};
export const mapB2CPaymentCardsToCommonModel = (cardType, paymentsCards, paginationInfo) => {
    const isPaypalCard = cardType === CardType.PAYPAL_ACCOUNT;
    const filteredPaymentsCards = paymentsCards.filter((card) => isPaypalCard ? !!card.paypalAccountId : !card.paypalAccountId);
    const mappedFilteredPaymentsCard = filteredPaymentsCards.map((card) => {
        var _a;
        const billingAddress = card.billingAddress;
        const postalDetails = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.postalDetails;
        return {
            addressId: (billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.addrIdentifier) || '',
            addressLine1: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.addressLine1) || '',
            addressLine2: postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.addressLine2,
            cardBrand: card.cardBrand || '',
            cardExpiryMonth: card.cardExpiryMonth || '',
            cardExpiryYear: card.cardExpiryYear || '',
            cardHolderName: card.cardHolderName || '',
            cardNickName: card.cardNickName,
            cardNumber: card.cardNumber || '',
            cardNumberLast4: card.cardNumberLast4 || '',
            cardStatus: undefined,
            cardType: card.cardType || '',
            city: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.city) || '',
            authorizeFlag: undefined,
            isCardExpired: card.isCardExpired,
            isDefault: card.isDefault || false,
            lastModifiedDate: card.lastModifiedDate,
            paymentId: card.paymentId || '',
            state: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.state) || '',
            zipCode: (postalDetails === null || postalDetails === void 0 ? void 0 : postalDetails.zipCode) || '',
            buyerId: card.buyerId || '',
            paypalAccountId: card.paypalAccountId,
            primaryPhone: { number: ((_a = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.primaryPhone) === null || _a === void 0 ? void 0 : _a.number) || '' },
            instantCheckoutDefault: card.instantCheckoutDefault,
        };
    });
    const mappedPaymentCardsLength = mappedFilteredPaymentsCard.length;
    const paymentCardsLength = Number(paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalNumberOfRecords);
    const restCardsLength = paymentCardsLength - mappedPaymentCardsLength;
    const mappedPaginationInfo = {
        pageNumber: Number(paginationInfo.pageNumber) || 0,
        pageSize: Number(paginationInfo.pageSize) || 0,
        totalCreditCards: (cardType === CardType.CREDIT_CARD
            ? mappedPaymentCardsLength
            : restCardsLength) || 0,
        totalPayPalAccounts: (cardType === CardType.PAYPAL_ACCOUNT
            ? mappedPaymentCardsLength
            : restCardsLength) || 0,
        totalGiftCards: 0,
        totalSearchedCreditCards: 0,
        totalProXtraDollars: 0,
        totalCheckingAccounts: 0,
        totalKeyTags: 0,
        totalLinesOfCredit: 0,
        totalPages: Number(paginationInfo.totalPages) || 0,
        paymentsOnCurrentPage: filteredPaymentsCards.length,
    };
    return {
        paymentCards: {
            paymentCards: mappedFilteredPaymentsCard,
            response: paymentsCards,
        },
        paginationInfo: mappedPaginationInfo,
        t2cApprovers: null,
    };
};
export const mapB2BEditCreditCardToRequestModel = (values, billingAddress, fullCreditCardData) => {
    const { isDefault, cardNickName, cardHolderName, cardExpiryMonth, cardExpiryYear, addressLine1, addressLine2, zipCode, cityState, } = values;
    const [cityName, stateCode] = cityState.split(', ');
    const addressId = billingAddress === null || billingAddress === void 0 ? void 0 : billingAddress.addressId;
    const { agreementCode, ein } = fullCreditCardData;
    const requestModel = Object.assign(Object.assign({}, fullCreditCardData), { billingAddress: {
            addressId: addressId || null,
            postalCode: zipCode,
            addressLine1,
            addressLine2: addressLine2 || '',
            cityName,
            stateCode,
            countryCode: billingAddress ? billingAddress.countryCode : 'US',
            name: billingAddress ? billingAddress.name : null,
            isDefault: billingAddress ? billingAddress.isDefault : null,
        }, isDefault, cardNickName: cardNickName || NULLIFY_FIELD, cardHolderName: cardHolderName || NULLIFY_FIELD });
    if (cardExpiryMonth && cardExpiryYear) {
        requestModel.cardExpiryMonth = cardExpiryMonth;
        requestModel.cardExpiryYear = cardExpiryYear;
    }
    if (agreementCode) {
        // To avoid API failures if agreementCode/eui field is empty or undefined
        requestModel.agreementCode = agreementCode || ' ';
        requestModel.ein = ein || ' ';
    }
    return requestModel;
};
export const mapB2CEditCreditCardToRequestModel = (values, fullCreditCardData) => {
    const { isDefault, cardNickName, cardHolderName, cardExpiryMonth, cardExpiryYear, billingAddressID, } = values;
    const requestModel = Object.assign(Object.assign({}, fullCreditCardData), { billingAddress: {
            addrIdentifier: billingAddressID,
        }, isDefault,
        cardNickName,
        cardHolderName });
    if (cardExpiryMonth && cardExpiryYear) {
        requestModel.cardExpiryMonth = cardExpiryMonth;
        requestModel.cardExpiryYear = cardExpiryYear;
    }
    return requestModel;
};
